import "./login.css";
import { useTranslation } from "react-i18next";

function Login(){
    const { t } = useTranslation();

  return(
    <>
      <div className="login-page">
                <div className="login-form">
<h2>{t("login_title")}</h2>
<p>{t("login_subtitle")}</p>

          <form>
<input placeholder={t("login_email")} />
<input placeholder={t("login_password")} />

<button>{t("login_button")}</button>
          </form>
        </div>

        {/* right image */}
        <div className="login-image">
          <div className="overlay">
            <h1>iNote Tech</h1>
            <p>Your Digital Partner</p>
          </div>
        </div>

      </div>
    </>
  )
}

export default Login;
